export class GenericError extends Error {
  title?: string;
  code?: string;

  constructor({
    title,
    message,
    code,
  }: {
    title?: string;
    message?: string;
    code?: string;
  }) {
    super(message);
    this.title = title;
    this.code = code;
  }
}
